<mwe-basic-card cardClass="ikp-basic-card-override">
  <div class="d-flex justify-content-between align-items-center gap-3">
    <h5 class="mb-0">{{ 'ummeldung.step.currentContractPartner.productOverviewCardTitle' | translate }}</h5>
    @if (frozen()) {
      <ikp-ummeldung-edit-inputs-button [dataTest]="dataTestIdPrefix() + '-button-editProduktdaten'" />
    }
  </div>
  <hr class="my-4 my-md-5" />
  @if (showIncompleteNotification()) {
    <mwe-inline-notification
      class="d-block mb-4"
      type="danger"
      titleKey="ummeldung.step.currentContractPartner.productOverviewIncompleteTitle"
      messageKey="ummeldung.step.currentContractPartner.productOverviewIncompleteDescription"
      link="ummeldung.step.currentContractPartner.productOverviewIncompleteLink"
      (onLinkClick)="navigateToProduktStep()"
    />
  }
  <div class="row g-3">
    <lib-ikp-text-field
      class="col-12 col-md-6"
      [dataTestId]="dataTestIdPrefix() + '-produkt'"
      label="ummeldung.step.currentContractPartner.product"
      [value]="'ummeldung.step.produkt.sparte.' + produkt() | translate"
    />

    <lib-ikp-text-field
      class="col-12 col-md-6"
      [dataTestId]="dataTestIdPrefix() + '-zaehlpunktAdresse'"
      label="ummeldung.step.currentContractPartner.meterpointAddress"
      [value]="adresseFormatted()"
    />

    <lib-ikp-text-field
      class="col-12 col-md-6"
      [dataTestId]="dataTestIdPrefix() + '-zaehlernummer'"
      label="ummeldung.step.currentContractPartner.meternumber"
      [value]="zaehlernummer()"
    />

    <lib-ikp-text-field
      class="col-12 col-md-6"
      [dataTestId]="dataTestIdPrefix() + '-zaehlpunkt'"
      label="ummeldung.step.currentContractPartner.meterpoint"
      [value]="zaehlpunktnummerFormatted()"
    />

    <lib-ikp-text-field
      class="col-12 col-md-6"
      [dataTestId]="dateInfo().dataTestId"
      [label]="dateInfo().label"
      [value]="dateInfo().value"
    />

    <lib-ikp-text-field
      class="col-12 col-md-6"
      [dataTestId]="dataTestIdPrefix() + '-zahlerstand'"
      label="ummeldung.step.currentContractPartner.metercount"
      [value]="zaehlerstandInfo()"
    />
  </div>

  @if (!isSmartMeter()) {
    <mwe-inline-notification class="d-block mt-3" messageKey="ummeldung.step.currentContractPartner.conventionalMeterInfotext" />
  }
</mwe-basic-card>
